import moment from 'moment';
import { IVitalSign, selectLastVitalSigns } from '../../../store/slices/vitalSigns';
import { useAppSelector } from '../../../store/store';
import style from './MainVitalScreen.module.scss';
import _ from 'lodash';
import { useTranslation } from '../../../hooks/useTranslations';

interface MainVitalScreenProps {
  setScreen: React.Dispatch<
    React.SetStateAction<'list' | 'report' | 'measurementTime' | 'manualRecord'>
  >;
}
const MainVitalScreen = ({ setScreen }: MainVitalScreenProps) => {
  const { translations } = useTranslation();
  const lastVitalsigns = useAppSelector(selectLastVitalSigns);
  function getLatestDateItems(data: IVitalSign[]) {
    if (!data || data.length === 0) {
      return [];
    }
    // Find the latest date
    const latestDate = data.reduce((latest, item) => {
      const currentDate = new Date(item.datetime_measure);
      const latestSoFar = new Date(latest);
      return currentDate > latestSoFar ? item.datetime_measure : latest;
    }, data[0].datetime_measure);

    // Filter items with the latest date
    const latestItems = data.filter((item) => {
      const itemDate = new Date(item.datetime_measure);
      const maxDate = new Date(latestDate);
      return itemDate.getTime() === maxDate.getTime();
    });
    return latestItems;
  }

  const lastVitalSignValues = getLatestDateItems(Object.values(lastVitalsigns)[0]);

  return (
    <div className={style.container}>
      <div className={style.measurmentComponent}>
        <div className={style.flexWrap}>
          {lastVitalSignValues?.map((item, idx) => {
            return (
              <div className={style.wrapper} key={idx}>
                <p className={style.txt}>
                  {translations(
                    `vitalSignProperties.${item.property_name.replace(/ /g, '_').toLowerCase()}`
                  )}
                </p>
                <p className={style.value} style={{ color: `#${item.color_code}` }}>
                  {item?.property_name === 'Body Weight' ? item.result_weight : item.property_value}
                </p>
                <p className={`${style.txt} ${style.gray}`}>{item.uom}</p>
              </div>
            );
          })}
        </div>
        {lastVitalSignValues.length > 0 ? (
          <p className={style.txt}>
            {moment(lastVitalSignValues[0]?.datetime_measure).format('DD.MM.YYYY - HH:mm')}
          </p>
        ) : (
          <p className={style.noResults}>{translations('noResults')}</p>
        )}
        <div
          className={`${style.flexWrap} ${style.mby}`}
          style={
            lastVitalSignValues.length > 0
              ? { flexDirection: 'column', maxWidth: '170px' }
              : { flexDirection: 'row' }
          }
        >
          <button className={style.blueBtn} onClick={() => setScreen('manualRecord')}>
            {translations('action.manual')}
          </button>
          <button className={style.transparentBtn} onClick={() => setScreen('measurementTime')}>
            {translations('measurement_plan')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MainVitalScreen;
